module.exports = '/ng-templates/features/record/jp-slider/jp-slider.tpl.ftl';
